import { Circle, useColorModeValue } from '@chakra-ui/react';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import SparkelIcon from 'src/components/common/icon/SparkelIcon';

interface TimelineDotProps {
  icon?: IconDefinition;
  isSelected?: boolean;
  size?: string;
  isCurrentVersion?: boolean;
}

export const TimelineDot: React.FC<TimelineDotProps> = ({
  icon,
  isSelected = false,
  size = '20px',
  isCurrentVersion = false,
}) => {
  const timelineColor = useColorModeValue('gray.400', 'gray.500');
  const timelineDotBackgroundColor = useColorModeValue('white', 'gray.800');
  const selectedBorderColor = useColorModeValue('blue.500', 'blue.300');
  const currentVersionColor = useColorModeValue('cyan.500', 'cyan.200');
  const selectedBgColor = useColorModeValue('blue.50', 'blue.800');

  // Current version dot has a special appearance
  if (isCurrentVersion) {
    return (
      <Circle
        size="14px"
        backgroundColor={timelineDotBackgroundColor}
        color="white"
        border="2px solid"
        borderColor={currentVersionColor}
      >
        <Circle
          size="6px"
          color="white"
          border="2px solid"
          borderColor={currentVersionColor}
        />
      </Circle>
    );
  }

  return (
    <Circle
      size={size}
      color={isSelected ? selectedBorderColor : timelineColor}
      backgroundColor={
        isSelected ? selectedBgColor : timelineDotBackgroundColor
      }
      border={isSelected ? '2px solid' : '1px solid'}
      borderColor={isSelected ? selectedBorderColor : timelineColor}
    >
      {icon && <SparkelIcon icon={icon} size="xs" color="inherit" />}
    </Circle>
  );
};

export default TimelineDot;
